import coulomb from './coulomb';
import lennardJones from './lennard-jones';

export default {
  coulomb,
  lennardJones
};
